let _ = require('lodash');
let { monkey } = require('baobab');
let progressBarHelper = require('../helpers/progress-bar');
let utils = require('../actions/utils.js');
let accountUi = require('../actions/accountUi.js');
let $ = require('jquery');
let zoom, frameWidth, frameHeight;
let dateFormatter = require('./dateFormatter');

function getScrollbarWidth (element) {
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    element.appendChild(outer);

    var widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";

    // add innerdiv
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    var widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode.removeChild(outer);

    return widthNoScroll - widthWithScroll;
}

module.exports = {
    getCurrentUser (args, state, output, { locator }) {
        try {
            let bitrix = locator.resolve('bitrix');
            bitrix.getCurrentUser((result) => output.success({ bitrixUser: result.data() }));
        } catch (error) {
            output.error({ error });
        }
    },

    getAuth (args, state, output, { locator }) {
        try {
            let bitrix = locator.resolve('bitrix');
            let auth = bitrix.getAuth();
            output.success({ auth });
        } catch (error) {
            output.error({ error });
        }
    },

    init (args, state, output, { locator }) {
        try {
            let bitrix = locator.resolve('bitrix');
            bitrix.init(() => output.success());
        } catch (error) {
            output.error({ error });
        }
    },

    resize ({ minHeight }, state, output, { locator }) {
        if (state.get(['bitrix', 'isBitrix']) === true) {
            let bitrix = locator.resolve('bitrix');
            let body = document.getElementById('hermes_body');
            let newWidth = parseFloat(body.getAttribute('cat-width'));
            let newHeight = _.max([$(body).height(), minHeight]);
            // если в предыдущем вызове текущий размер фрейма уже был установлен, то ничего не делаем
            if (newWidth === frameWidth && newHeight === frameHeight) {
                return;
            }
            frameWidth = newWidth;
            frameHeight = newHeight;
            bitrix.resize(newWidth, newHeight);
        }
    },

    scrollTop (args, state, output, { locator }) {
        if (state.get(['bitrix', 'isBitrix']) === true) {
            let bitrix = locator.resolve('bitrix');
            bitrix.scroll(0);
        }
    },

    fitWindow (args, state, output, { locator }) {
        if (state.get(['bitrix', 'isBitrix']) === true) {
            let bitrix = locator.resolve('bitrix');
            let body = document.getElementById('hermes_body');

            $(window).resize(function () {
                let zoomNew = document.documentElement.clientWidth;
                if (Math.abs(zoom - zoomNew) > 0) {
                    // изменился зум, изменим размер фрейма
                    zoom = zoomNew;
                    bitrix.fitWindow(() => {
                        body.setAttribute('cat-width', $(body).width() + getScrollbarWidth(body));
                    });
                }
            });

            if (body.getAttribute('cat-width')) {
                return;
            }
            bitrix.fitWindow(() => {
                body.setAttribute('cat-width', $(body).width() + getScrollbarWidth(body));
                zoom = document.documentElement.clientWidth;
            });
        }
    },

    exportLeads ({ leadMapping, isExportFree, isIncludeExportedFreeLeads }, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);

        let request = API.exportLeads(context, locator, {
            orderId, leadMapping, isExportFree,
            isIncludeExportedFreeLeads
        });
        request.then((response) => {
            let code = _.get(response, 'status.code');
            if (code === 403) {
                output.forbidden();
                return;
            }

            if (code !== 200) {
                output.error({ error: code });
                return;
            }
            output.success({ exportJobId: _.get(response, 'content') });
        }).catch((error) => output.error({ error }));
    },

    getLeadFields (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        let request = API.getLeadFields(context, locator, { orderId });
        request.then((response) => {
            let code = _.get(response, 'status.code');
            if (code !== 200) {
                output.error({ error: code });
                return;
            }
            output.success({ leadFields: _.get(response, 'content') });
        }).catch((error) => output.error({ error }));
    },

    initBitrixLeads ({ leadFields }, state) {
        let bitrixFields = _.map(leadFields.bitrixFields, (x) => ({ isActive: false, title: x.name, value: x.id }));
        let hermesFields = leadFields.hermesFields;
        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'hasFieldCreationRight'],
            leadFields.hasFieldCreationRight);
        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'freeLeadsAmount'],
            leadFields.freeLeadsAmount);
        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isOnlyFreeLeads'],
            leadFields.isOnlyFreeLeads);
        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'hermesFields'], hermesFields);
        _.forEach(hermesFields, (item) => {
            let itemBitrixFields = _.cloneDeep(_.filter(bitrixFields, (x) => item.acceptableMapping.includes(x.value)));
            let ignoreField = { isActive: false, title: '- Не экспортировать -', value: '-1' };
            let selectedIndex = _.findIndex(itemBitrixFields, { value: item.defaultMapping });
            if (selectedIndex > -1) {
                itemBitrixFields[selectedIndex].isActive = true;
            } else {
                ignoreField.isActive = true;
            }
            itemBitrixFields.unshift(ignoreField);
            state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', item.id, 'id'],
                item.id);
            state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', item.id, 'bitrixFields'],
                itemBitrixFields);
            state.set(['account', 'popups', 'bitrixExportLeads', 'mapping', item.id, 'isOpen'], monkey([
                ['popups', 'active'],
                (popups) => _.includes(popups, `leads${item.id}`)
            ]));
        });

        let requiredFields = _.filter(leadFields.bitrixFields, { isRequired: true });
        // преобразуем значением enum в вид, который используется в выпадающем списке Select
        // boolean инициализируем значением false, чтобы пользователь без клика и отклика мог сразу выгрузить false
        if (requiredFields) {
            _.forEach(requiredFields, (item) => {
                if (item.type === 'enumeration') {
                    item.enumValues = _.map(Object.keys(item.enumValues),
                        (key) => ({ isActive: false, title: item.enumValues[key], value: key }));
                    utils.setPopupVisibility(`lead-required-field-${item.id}`,
                        ['account', 'popups', 'bitrixExportLeads', 'requiredFields', item.id, 'isOpen'])({}, state);
                } else if (item.type === 'boolean') {
                    item.value = false;
                    // для нас при валидации нет разницы между разными типами чисел
                } else if (item.type === 'integer' || item.type === 'double' || item.type === 'money') {
                    item.type = 'number';
                    // для нас при валидации нет разницы между типом url и string
                } else if (item.type === 'url') {
                    item.type = 'string';
                    // для нас при валидации нет разницы между типом date и datetime
                } else if (item.type === 'date' || item.type === 'datetime') {
                    item.type = 'datetime';
                    utils.setPopupVisibility(`lead-required-field-${item.id}`,
                        ['account', 'popups', 'bitrixExportLeads', 'requiredFields', item.id, 'isOpen'])({}, state);
                    accountUi.setDatePickerComputed(item.id, ['account', 'orders', 'currentOrder', 'bitrixExportLeads',
                            'computed', 'requiredFields', item.id, 'datepicker'],
                        ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields', item.id,
                            'datepicker'], state);
                }
            });
        }
        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields'],
            _.keyBy(requiredFields, (x) => x.id));
    },

    selectBitrixLeadField ({ field, selectedValue }, state) {
        let options = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', field,
            'bitrixFields']);
        let oldSelectedValueIndex = _.findIndex(options, { isActive: true });
        if (oldSelectedValueIndex > -1) {
            state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', field, 'bitrixFields',
                oldSelectedValueIndex, 'isActive'], false);
        }
        let selectedIndex = _.findIndex(options, { value: selectedValue });
        if (selectedIndex > -1) {
            state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', field, 'bitrixFields',
                selectedIndex, 'isActive'], true);
        }
    },

    addLeadMappingToArgs (args, state) {
        let mappingState = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping']);
        let mapping = [];
        _.forEach(Object.keys(mappingState), (key) => {
            if (mappingState[key].isNew) {
                mapping.push({
                    from: key,
                    newLabel: mappingState[key].newLabel
                });
                return;
            }
            let bitrixFields = mappingState[key].bitrixFields;
            let selectedIndex = _.findIndex(bitrixFields, { isActive: true });
            if (selectedIndex > -1) {
                // Если выбран элемент "Не экспортировать", то игнориуем поле
                if (bitrixFields[selectedIndex].value === '-1') {
                    return;
                }
                mapping.push({
                    from: key,
                    to: bitrixFields[selectedIndex].value
                });
            }
        });
        // если есть какие-то незаполненные обязательные поля, но пользователь указал для них значение руками
        // то добавляем их в маппинг
        let required = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredBitrixFields']);
        let requiredValues = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields']);
        _.forEach(required, (item) => {
            let value = _.get(requiredValues[item.id], 'value', undefined);
            if (value) {
                mapping.push({
                    to: item.id,
                    value: value.toString()
                });
            } else {
                let date = _.get(requiredValues[item.id], 'datepicker.value', undefined);
                if (date) {
                    mapping.push({
                        to: item.id,
                        value: dateFormatter.getFormattedDate(date)
                    });
                }
            }
        });

        args.leadMapping = JSON.stringify(mapping);
        args.isExportFree = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isExportFree']);
        // если пользватель поставил галку "Повторно выгрузить бесплатные лиды", то isIncludeExportedFreeLeads = true
        // если в заказе все лиды бесплатные, то isIncludeExportedFreeLeads = true
        args.isIncludeExportedFreeLeads = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads',
            'isIncludeExportedFreeLeads']) || state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads',
            'isOnlyFreeLeads']);
    },

    getExportJobProgress ({ exportJobId }, state, output, { locator, context }) {
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        let API = locator.resolve('api');
        progressBarHelper.init('export-leads', 'Экспорт лидов');
        setTimeout(function getExportJobProgress () {
            if (state.get(['account', 'orders', 'currentOrder', 'id']) !== orderId) {
                output.dontNeed();
                return;
            }

            let request = API.getExportJobProgress(context, locator, { exportJobId });
            request.then((data) => {
                if (state.get(['account', 'orders', 'currentOrder', 'id']) !== orderId) {
                    output.dontNeed();
                    return;
                }

                let statusCode = _.get(data, 'status.code');
                if (statusCode !== 200) {
                    output.error({ error: statusCode });
                    return;
                }

                let jobProgress = _.get(data, 'content', 0);
                if (isNaN(jobProgress)) {
                    jobProgress = 0;
                }
                // Обновить ui прогресс
                progressBarHelper.setPercentage('export-leads', jobProgress);
                if (jobProgress >= 100) {
                    output.success();
                } else {
                    setTimeout(getExportJobProgress, 2500);
                }
                return;
            }).catch((error) => {
                output.error({ error });
                return;
            });
        }, 0);
    },

    fillRegistrationForm ({ bitrixUser }, state) {
        state.set(['registrationExtra', 'form', 'firstName'], bitrixUser.NAME);
        state.set(['registrationExtra', 'form', 'lastName'], bitrixUser.LAST_NAME);
        state.set(['registrationExtra', 'form', 'middleName'], bitrixUser.SECOND_NAME);
        state.set(['registrationExtra', 'form', 'city'], bitrixUser.PERSONAL_CITY);

        let phone = bitrixUser.PERSONAL_MOBILE || bitrixUser.WORK_PHONE;
        if (phone) {
            phone = phone.replace(/[^0-9]/g, '');
            if (phone.length === 11 && (phone.charAt(0) === '7' || phone.charAt(0) === '8')) {
                phone = phone.substring(1);
            }
            if (phone.length !== 10) {
                phone = null;
            }
            state.set(['registrationExtra', 'form', 'phone'], phone);
        }
    },

    validateMapping (args, state) {
        let mapping = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping']);
        let mappingNotNew = _.filter(mapping, (x) => !x.isNew);
        let grouped = _.groupBy(mappingNotNew, (x) => _.find(x.bitrixFields, { isActive: true }).value);
        let duplicatesCount = 0;
        let required = _.cloneDeep(state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads',
            'requiredFields']));
        _.forEach(Object.keys(grouped), (key) => {
            delete required[key];
            if (grouped[key].length < 2 || key === '-1') {
                _.forEach(grouped[key], (x) => {
                    state.unset(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', x.id, 'isError']);
                });
                return;
            }
            duplicatesCount++;
            _.forEach(grouped[key], (x) => {
                state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', x.id, 'isError'], true);
            });
        });

        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'missRequiredFields'],
            _.map(required, (x) => x.name));
        // иногда у пользователей есть обязательные поля, но у нас нет для этих полей никаких данных
        // в этом случае у пользователя должна быть возможность записать туда значение руками
        // для этого мы должны понимать какого типа значение в поле можно записать и валидировать его
        let knownTypes = ['number', 'string', 'boolean', 'enumeration', 'datetime'];
        let requiredKnownTypes = _.filter(required, (x) => knownTypes.includes(x.type));
        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredBitrixFields'],
            requiredKnownTypes);

        let requiredValues = state.get(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields']);
        if (requiredValues) {
            _.forEach(Object.keys(requiredValues), (key) => {
                if (!requiredValues[key].error && (requiredValues[key].value ||
                        _.get(requiredValues[key], 'datepicker.value'))) {
                    delete required[key];
                }
            });
        }

        let mappingNewErrors = _.some(mapping, (x) => x.isNew && (x.error || !x.newLabel));
        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'duplicateError'], duplicatesCount > 0);
        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isError'],
            duplicatesCount > 0 || Object.keys(required).length > 0 || mappingNewErrors);
    },

    setTypeFilterItem ({ path, value }, state) {
        state.set(['account', 'orders', 'list', 'typeFilter', path, 'isChecked'], value);
    },

    setBitrixRequiredFieldValue ({ path, value }, state) {
        state.set(['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredFields', path, 'value'], value);
    }
};



// WEBPACK FOOTER //
// ./actions/bitrix.js